import {
  delay,
  http,
  HttpResponse,
} from 'msw';

import { createCsvMockEndpoint } from '@/mocks/create-csv-mock-endpoint';
import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { BankPayTransactionIndexDownloadResponse } from '@/repositories/generated';

const response: BankPayTransactionIndexDownloadResponse = {
  presignedUrl: createCsvMockEndpoint([
    ['取引日時', '決済処理通番', '処理番号', '決済種別', '取引種別', '取引金額', 'ステータス', '承認番号', 'ユーザID', '外部ユーザID', '決済手段登録番号', 'Pay事業者ID', 'ウォレットサービス', 'Bank Pay加盟店名', 'Bank Pay加盟店ID', 'Bank Pay店舗名', 'Bank Pay店舗ID', 'Bank Pay顧客ID', '加盟店処理通番', '端末機識別番号', '端末処理通番', 'BP通信情報処理センタID', '返品済金額', '返品可否', '元取引処理番号', '元取引金額', '元取引加盟店処理通番', '元取引端末機識別番号', '元取引端末処理通番', 'エラーコード', 'エラーメッセージ'],
  ]),
};

export const splitPaymentDownload = http.get(
  createMockEndpoint('/bankpay_transaction/download'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
